import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { UnifiedSurveyReportManagement } from '../survey-report/components/UnifiedSurveyReportManagement';
import ReportViewPage from './pages/ReportViewPage';

export const ReportsRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Always render same component - no conditional logic to prevent flicker */}
      <Route index element={<UnifiedSurveyReportManagement />} />
      <Route path=":reportId/view" element={<ReportViewPage />} />
    </Routes>
  );
};
